export default __webpack_public_path__ + "11cc8c47c96e651921a7b8ab61f599e9.png";